// why-trackmate images
import why_trackmate_1 from "@/assets/images/why-trackmate/benefits/benefit_1.jpg";
import why_trackmate_2 from "@/assets/images/why-trackmate/benefits/benefit_2.jpg";
import why_trackmate_3 from "@/assets/images/why-trackmate/benefits/benefit_3.jpg";
import why_trackmate_4 from "@/assets/images/why-trackmate/benefits/benefit_4.jpg";

// why-trackmate icons
import take_control_icon_1 from "@/assets/icons/why-trackmate/take-control/map-pin.svg";
import take_control_icon_2 from "@/assets/icons/why-trackmate/take-control/bell-alert.svg";
import take_control_icon_3 from "@/assets/icons/why-trackmate/take-control/document-text.svg";
import take_control_icon_4 from "@/assets/icons/why-trackmate/take-control/adjustments-vertical.svg";
import save_costs_icon_1 from "@/assets/icons/why-trackmate/save-costs/receipt-percent.svg";
import save_costs_icon_2 from "@/assets/icons/why-trackmate/save-costs/circle-stack.svg";
import save_costs_icon_3 from "@/assets/icons/why-trackmate/save-costs/wrench-screwdriver.svg";
import save_costs_icon_4 from "@/assets/icons/why-trackmate/save-costs/presentation-chart-line.svg";
import enhance_safety_icon_1 from "@/assets/icons/why-trackmate/enhance-safety/bolt.svg";
import enhance_safety_icon_2 from "@/assets/icons/why-trackmate/enhance-safety/eye.svg";
import enhance_safety_icon_3 from "@/assets/icons/why-trackmate/enhance-safety/exclaimation-circle.svg";
import enhance_safety_icon_4 from "@/assets/icons/why-trackmate/enhance-safety/light-bulb.svg";
import improve_productivity_icon_1 from "@/assets/icons/why-trackmate/improve-productivity/check-badge.svg";
import improve_productivity_icon_2 from "@/assets/icons/why-trackmate/improve-productivity/briefcase.svg";
import improve_productivity_icon_3 from "@/assets/icons/why-trackmate/improve-productivity/wallet.svg";
import improve_productivity_icon_4 from "@/assets/icons/why-trackmate/improve-productivity/leaf.svg";

// features
import telematic_image from "@/assets/images/features/telematic.png";
import telematic_thumbnail from "@/assets/images/features/telematic_thumbnail.png";
import compliance_image from "@/assets/images/features/compliance.png";
import compliance_thumbnail from "@/assets/images/features/compliance_thumbnail.png";
import alerts_image from "@/assets/images/features/alerts.png";
import alerts_thumbnail from "@/assets/images/features/alerts_thumbnail.png";
import reports_image from "@/assets/images/features/reports.png";
import reports_thumbnail from "@/assets/images/features/reports_thumbnail.png";

// help-desk icons
import chat_bubble_icon from "@/assets/icons/help-desk/chat-bubble-left-right.svg";
import question_mark_icon from "@/assets/icons/help-desk/question-mark-circle.svg";
//import bolt_icon from "@/assets/icons/help-desk/bolt.svg";
import rectangle_icon from "@/assets/icons/help-desk/rectangle-stack.svg";
import rocket_icon from "@/assets/icons/help-desk/rocket-launch.svg";

import cpu_chip_icon from "@/assets/icons/help-desk/cpu-chip.svg";
//import document_duplicate_icon from "@/assets/icons/help-desk/document-duplicate.svg";
import book_open_icon from "@/assets/icons/help-desk/book-open.svg";
import shield_check_icon from "@/assets/icons/help-desk/shield-check.svg";

// troubleshooting icons
import log_in_icon from "@/assets/icons/troubleshooting/log-in.svg";
import reporting_icon from "@/assets/icons/troubleshooting/reporting.svg";
import bell_slash_icon from "@/assets/icons/troubleshooting/bell-slash.svg";
import no_data_icon from "@/assets/icons/troubleshooting/no-data.svg";
import map_mark_icon from "@/assets/icons/troubleshooting/map-mark.svg";
import low_battery_icon from "@/assets/icons/troubleshooting/low-battery.svg";
import { ROUTES } from "../navigation";

export const whyTrackmateData = [
  {
    title: "Ultimate Piece of Mind, All the Time",
    subtitle:
      "Whether managing a personal vehicle, a company fleet, or any valuable asset, managing its location is important 24/7. We are here to help.",
    imageUrl: why_trackmate_1,
    benefits: [
      {
        iconUrl: take_control_icon_1,
        description: "Access real-time location updates for your vehicle or asset with a live map.",
      },
      {
        iconUrl: take_control_icon_2,
        description:
          "Review detailed route histories and travel logs for your vehicles or fleets.",
      },
      {
        iconUrl: take_control_icon_3,
        description:
          "Receive notifications when your vehicle enters or exits specified zones.",
      },
      {
        iconUrl: take_control_icon_4,
        description: "Manage your vehicle remotely, including door locks and ignition control.",
      },
    ],
  },
  {
    title: "Save costs",
    subtitle:
      "Trackmate can lead to significant cost savings for both personal and business use. Use real-time data on location and movement of a vehicle to help optimize routes.",
    imageUrl: why_trackmate_2,
    benefits: [
      {
        iconUrl: save_costs_icon_1,
        description:
          "Get insurance premium discounts based on better driver assessments.",
      },
      {
        iconUrl: save_costs_icon_2,
        description:
          "Reduce fuel costs by reducing aggressive driving behavior and optimized routes",
      },
      {
        iconUrl: save_costs_icon_3,
        description:
          "Reduce costs related to wear and tear on vehicles and maintenance",
      },
      {
        iconUrl: save_costs_icon_4,
        description:
          "See an immediate impact on ROI with efficient routes and better driver behavior.",
      },
    ],
  },
  {
    title: "Enchance safety",
    subtitle:
      "Trackmate has become an essential tool for enhancing safety on the road.",
    imageUrl: why_trackmate_3,
    benefits: [
      {
        iconUrl: enhance_safety_icon_1,
        description:
          "Monitor your drivers’ speed and get alerts when vehicle exceeds a limit",
      },
      {
        iconUrl: enhance_safety_icon_2,
        description: "Enhance driver performance with GPS insights",
      },
      {
        iconUrl: enhance_safety_icon_3,
        description:
          "Keep vehicles in safe driving condition with maintenance alerts and reminders",
      },
      {
        iconUrl: enhance_safety_icon_4,
        description:
          "Respond to an emergency quickly and easily with our SOS feature",
      },
    ],
  },
  {
    title: "Improve Productivity, Performance & Compliance",
    subtitle:
      "Trackmate provides you with reports and services you can use to better run your business. ",
    imageUrl: why_trackmate_4,
    benefits: [
      {
        iconUrl: improve_productivity_icon_1,
        description:
          "Optimize routes with real-time data and reports on vehicle location and movement",
      },
      {
        iconUrl: improve_productivity_icon_2,
        description:
          "Monitor driver activity for performance, billability and payroll",
      },
      {
        iconUrl: improve_productivity_icon_3,
        description:
          "Save time on compliance, automating driving hours and paperwork",
      },
      {
        iconUrl: improve_productivity_icon_4,
        description:
          "Be better on the environment by reducing your carbon footprint",
      },
    ],
  },
];

export const featuresData = [
  {
    title: "Telematics",
    description:
      "Simple, affordable, and scalable. Telematics is a user-friendly solution suitable for both business and personal applications.",
    imageUrl: telematic_image,
    thumbnail: telematic_thumbnail
  },
  {
    title: "Compliance",
    description:
      "Keep up with current regulatory frameworks and laws without missing a beat.",
    imageUrl: compliance_image,
    thumbnail: compliance_thumbnail
  },
  {
    title: "Alerts",
    description:
      "Configure custom alerts to send to key stakeholders based on your preferences. ",
    imageUrl: alerts_image,
    thumbnail: alerts_thumbnail
  },
  {
    title: "Reports",
    description:
      "Easy to configure, generate, and understand, Trackmate helps you collaborate with ease.",
    imageUrl: reports_image,
    thumbnail: reports_thumbnail
  },
];

export const otherFeaturesData = [
  {
    title: "Instant Alerts",
    description:
      "Customize alerts to key stakeholders to indicate vehicle condition, location, and more.",
    imageUrl: alerts_image,
  },
  {
    title: "Detailed Reporting",
    description:
      "Configure reports to compile and send automatically to enable better business decisions.",
    imageUrl: reports_image,
  },
  {
    title: "Compliance",
    description:
      "Trackmate automatically updates when frameworks change, so you’ll always be on top of the latest requirements.",
    imageUrl: compliance_image,
  },
];

export const helpDeskData = [
  {
    iconUrl: rocket_icon,
    title: "Getting started",
    description:
      "Your step-by-step guide to setting up and using your Trackmate devices.",
    description_end: null,
    withArrow: true,
    withContacts: false,
    path: ROUTES.getTrackmate,
  },
  {
    iconUrl: rectangle_icon,
    title: "Installation guides",
    description:
      "Detailed manuals to help you install and configure your Trackmate devices properly.",
    description_end: null,
    withArrow: true,
    withContacts: false,
    path: ROUTES.installationGuide,
  },
  // {
  //   iconUrl: bolt_icon,
  //   title: "Troubleshooting",
  //   description:
  //     "Find solutions to common issues and get tips on resolving any technical difficulties.",
  //   description_end: null,
  //   withArrow: true,
  //   withContacts: false,
  //   path: ROUTES.troubleshooting,
  // },
  {
    iconUrl: question_mark_icon,
    title: "FAQs",
    description:
      "Answers to the most frequently asked questions about our products and services.",
    withArrow: true,
    path: ROUTES.faq,
  },
  {
    iconUrl: chat_bubble_icon,
    title: "Technical support",
    description: null,
    withArrow: false,
    path: null,
  },
];

export const productHelpData = [
  {
    iconUrl: cpu_chip_icon,
    title: "Device Overview",
    description: "Learn about the features and capabilities of Trackmate devices.",
    withArrow: true,
    path: ROUTES.solutions,
  },
  // {
  //   iconUrl: document_duplicate_icon,
  //   title: "API Integration",
  //   description:
  //     "Seamlessly integrate Trackmate with your existing applications using our API.",
  //   withArrow: true,
  //   path: ROUTES.APIintegration,
  // },
  {
    iconUrl: book_open_icon,
    title: "Feature Guides",
    description: "In-depth guides on how to utilize all the features Trackmate offers.",
    withArrow: true,
    path: ROUTES.features,
  },
  {
    iconUrl: shield_check_icon,
    title: "Product Updates",
    description: "Stay informed about the latest features and improvements.",
    withArrow: true,
    path: ROUTES.resources,
  },
];

export const popularArticlesData = [
  {
    label: "Why can’t I access the device dashboard after installation?",
    href: ROUTES.articleDetails,
  },
  {
    label: "Do I need to have Bluetooth enabled frequently?",
    href: ROUTES.articleDetails,
  },
  {
    label: "How can I customize geofencing settings?",
    href: ROUTES.articleDetails,
  },
  {
    label: "What are the best practices for battery management?",
    href: ROUTES.articleDetails,
  },
  {
    label: "Why is my Trackmate device showing offline?",
    href: ROUTES.articleDetails,
  },
  {
    label: "How can I improve my device's responsiveness?",
    href: ROUTES.articleDetails,
  },
  {
    label: "How do I set up and manage alerts for different events on my device?",
    href: ROUTES.articleDetails,
  },
];

export const troubleshootingData = [
  {
    iconUrl: log_in_icon,
    title: "Platform login issues",
    description: "Users are unable to log in to the Trackmate platform.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
  {
    iconUrl: reporting_icon,
    title: "Delayed reporting",
    description:
      "The device is reporting location data with a significant delay.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
  {
    iconUrl: bell_slash_icon,
    title: "Alerts not functioning as expected.",
    description: "Alerts are not triggering or are providing inaccurate information.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
  {
    iconUrl: no_data_icon,
    title: "No data displayed on the platform",
    description: "The Trackmate platform is not showing any data or is failing to update.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
  {
    iconUrl: map_mark_icon,
    title: "Inaccurate location reporting",
    description: "The device is providing incorrect location information.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
  {
    iconUrl: low_battery_icon,
    title: "Battery draining quickly",
    description: "The device battery is depleting faster than expected.",
    description_end: null,
    withArrow: true,
    withContacts: false,
  },
];
